import { Outlet, ScrollRestoration } from 'react-router-dom';
import { TopNav, MobileSearchBar } from './top-nav';
import { MobileBottomNav, MobileBottomSpacer } from './mobile-bottom-nav';
import { BrandSection } from './brand-section';
import { Footer } from './footer';
import { SkipLink } from '@/components/common/skip-link';

export const PublicLayout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SkipLink />
      <TopNav />
      <MobileSearchBar />
      <main id="main" tabIndex={-1} className="flex-1">
        <Outlet />
      </main>
      <MobileBottomSpacer />
      <MobileBottomNav />
      <BrandSection />
      <Footer />
      <ScrollRestoration />
    </div>
  );
};
